import * as React from 'react'

const SvgArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.125 16.25l.881-.881-4.737-4.744h13.856v-1.25H4.269l4.737-4.744-.881-.881L1.875 10l6.25 6.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowLeftIcon
